import { split } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { WebSocketLink } from '@apollo/client/link/ws'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { isUpload, isSubscriptionOperation } from './helpers'
import { withAuth, getSubscriptionParams } from './auth'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { RetryLink } from '@apollo/client/link/retry'

const graphqlUrl = process.env.REACT_APP_ENDPOINT_GRAPHQL
const subscriptionstUrl = process.env.REACT_APP_ENDPOINT_SUBSCRIPTIONS

const subscriptionClient = new SubscriptionClient(
	subscriptionstUrl,
	{
		// timeout: 20000,
		// lazy: true,
		reconnect: true,
		connectionParams: getSubscriptionParams
	}
)
const webSocketLink = new WebSocketLink(subscriptionClient)


const retryLink = withAuth.concat(new RetryLink({
	delay: { initial: 1000 },
	attempts: {
		max: 3,
		retryIf: (error, operation) => operation?.operationName !== 'getClosingsReport'
	}

}))

const batchLink = retryLink.concat(new BatchHttpLink({ uri: graphqlUrl }))
const uploadLink = retryLink.concat(createUploadLink({ uri: graphqlUrl }))


const requestLink = split(isSubscriptionOperation, webSocketLink, batchLink)
const terminalLink = split(isUpload, uploadLink, requestLink)


export default terminalLink
